import { memo } from 'react';
import { Field } from 'formik';
import { useTranslation } from 'react-i18next';
import { Select } from 'antd';

// Import components
import { Field as FormField, SelectField } from 'components/elements';
import { Button } from 'components/elements/atoms/Button/Button';

const { Option } = Select;

type Params = {
	isSubmitting: boolean;
	isEnabled: boolean;
};

const ParentalControlFields = ({ isSubmitting, isEnabled }: Params) => {
	const { t } = useTranslation();

	return (
		<>
			{isEnabled ? (
				<Field placeholder={t('parental_control_pin')} name="pin" type="text" component={FormField} autoComplete="off" />
			) : (
				<Field name="rating" component={SelectField}>
					<Option value={0}>{t('parental_control_no_age_limits')}</Option>
					<Option value={7}>{t('parental_control_seven_age_limits')}</Option>
					<Option value={12}>{t('parental_control_twelve_age_limits')}</Option>
					<Option value={16}>{t('parental_control_sixteen_age_limits')}</Option>
					<Option value={18}>{t('parental_control_eighteen_age_limits')}</Option>
				</Field>
			)}

			<Button type="submit" disabled={isSubmitting} isLoading={isSubmitting} variant="primary" modifiers={['contained', 'small']}>
				{isEnabled ? t('parental_control_btn_enabled') : t('parental_control_btn_active')}
			</Button>
		</>
	);
};

export default memo(ParentalControlFields);
